import React from "react";
import style from "./index.module.scss";
import { TiArrowBackOutline } from "react-icons/ti";
import { Icon } from "antd";

import moment from "moment";
import { ChatMessageItem } from "../../types";
import { copyToClipboard, getFullMessageText } from "../../Utils/common";

interface RightMenuProps {
    msg?: ChatMessageItem; //选中的消息
    handleRetract: () => void;
    handleDelete: () => void;
}

export const RightMenuOnMyText = ({
    msg,
    handleRetract,
    handleDelete
}: RightMenuProps) => {
    //三分钟内可以撤回
    const threeMinuteAgo = moment().subtract(3, "minute");
    const isShow =
        msg?.sendDate && moment(msg.sendDate).isAfter(threeMinuteAgo);

    return (
        <div className={style.root}>
            {isShow && (
                <div className={style.item} onClick={handleRetract}>
                    <TiArrowBackOutline className={style.icons} />
                    撤回
                </div>
            )}

            <div className={style.item} onClick={handleDelete}>
                <Icon type="delete" className={style.icons} />
                删除
            </div>
            <div
                className={style.item}
                onClick={() => copyToClipboard(getFullMessageText(msg))}>
                <Icon type="copy" className={style.icons} />
                复制
            </div>
        </div>
    );
};
